// extracted by mini-css-extract-plugin
module.exports = {"label":"Radio_label__q7oyo"};